import { v4 as uuid } from 'uuid'
import { Meta } from '@weblite-wapps/protocol'

const awaitingParentResolvers: Record<string, (value: unknown) => void> = {}

export const registerAwaitingParentWapp = (parent: Meta) => {
  const { wappSessionId } = parent
  if (awaitingParentResolvers[wappSessionId]) return

  return new Promise(resolve => {
    awaitingParentResolvers[wappSessionId] = resolve
  })
}

export const registerAwaitingParent = (resolve: (value: any) => any) => {
  const id = uuid()
  awaitingParentResolvers[id] = resolve

  return id
}

export const resolveAwaitingParent = (id: string, output: unknown) => {
  awaitingParentResolvers[id]?.(output)
  delete awaitingParentResolvers[id]
}
